import React from 'react'
import ErrorBoundary from '../ErrorBoundary/ErrorBoundary'

const ErrorPage = () => {
  return <ErrorBoundary error={500} />
}

export default ErrorPage